<template lang="pug">
    .financial-table
        .row(v-for="k in Object.keys(infoObj)" v-if="FinancialDict[k]" :key="k")
            span {{FinancialDict[k]}} :
            strong {{infoObj[k]}}
</template>

<script>
const FinancialDict = {
    assets_liabilities: '资产负债率(%)',
    cash_flow_per_share: '每股经营性现金流(元/股)',
    current_ratio: '流动比率(%)',
    index_per_share: '每股指标(元/股)',
    net_assets_per_share: '每股净资产(元/股)',
    net_profit: '净利润(元)',
    net_profit_rate: '归属净利润同比增(%)',
    profit_per_share: '每股未分配利润(元/股)',
    provident_fund_per_share: '每股公积金(元/股)',
    quick_ratio: '速动比率(%)',
    revenue: '营业收入(元)',
    revenue_rate: '营业收入同比增(%)',
    turnover_days_accounts_receivable: '应收账款周转天数(天/次)',
    turnover_rate_total_assets: '总资产周转率(次)',
};

export default {
    name: 'FinancialReport',
    props: {
        info: String,
    },
    computed: {
        infoObj() {
            if (!this.info) return null;
            let obj = null;
            try {
                obj = JSON.parse(this.info);
            } catch (e) {
                console.log(e);
            }
            return obj;
        },
        FinancialDict() {
            return FinancialDict;
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="stylus" scoped>
.row
    display flex
    justify-content space-between
</style>
